import { useQuery } from "@tanstack/react-query";

import { getSessionUser } from "../services/auth";

export const useSessionUser = () => {
  return useQuery({
    queryFn: async () => {
      const response = await getSessionUser();
      return response;
    },
    queryKey: ["sessionUser"],
    refetchOnWindowFocus: false,
    retry: 2,
  });
};
